import { SolitoImage } from 'solito/image';
import { styled, YStack } from 'tamagui';

const ImageWrapper = styled(YStack, {
  position: 'relative',
  width: '100%',
  minWidth: 320,
  // maxWidth: 320,
  maxHeight: '100%',
  minHeight: '100%',
  aspectRatio: 3 / 2,
});

type ImageProps = {
  src: string;
  alt: string;
  priority?: boolean;
  loading?: 'lazy' | 'eager';
  fit?: "none" | "contain" | "fill" | "cover" | "scale-down";
};

export const ResponsiveImage = ({
  src,
  alt,
  priority = false,
  loading = 'lazy',
  fit = 'contain',
}: ImageProps) => (
  <ImageWrapper>
    <SolitoImage
      src={src}
      alt={alt}
      fill
      sizes="(max-width: 600px) 100vw, 600px"
      style={{ objectFit: fit }}
      // priority={priority}
      // loading={loading}
      {...(!priority && { loading })}
    />
  </ImageWrapper>
);
